var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"elevation-0",attrs:{"tabs":"","app":"","fixed":"","dense":"","prominent":"","color":_vm.color}},[_c('v-toolbar-title',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('v-spacer'),_c('v-btn',{attrs:{"flat":"","icon":""},on:{"click":_vm.logOut}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ed4022","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolBar.vue
// module id = null
// module chunks = 